import MeaPage from "../../../components/MeaPage";
import { useRef } from "react";
import EventsListComponent from "./components/EventsListComponent";

const EventsListPage = () => {
  //
  const listRef = useRef();
  //
  return (
    <>
      <MeaPage
        //breadcrumb={<SlotsBreadCrumb />}
        title="Agenda"
        subtitle="Gérez l'ensemble des événements durant la formation"
      >
        <EventsListComponent
          ref={listRef}
          showAddButton={true}
          showFilterButton={true}
        />
      </MeaPage>
    </>
  );
};
export default EventsListPage;
